export default {
  primary: "#FB7B70",
  secondary: "#9597C8",
  third: "#84CEC1",
  background: "#FAFAFA",
  text: "#444444",
  subtext: "#A29CA3",
  textSecondary: "#8D99AE",
  textWhite: "#FFFFFF",
  textBlack: "#000000",
  textError: "#FF0000",
  textSuccess: "#20D489",
  textWarning: "#eab308",
  textInfo: "#0000FF",
  textDisabled: "#A9A9A9",
  bgWarning: "#fef9c3",
  bgError: "#FFE2E2",
  bgSuccess: "#DFF6CC",

  textAprroved: "#5ED300",
  bgAprroved: "#DFF6CC"
};
